import { render, staticRenderFns } from "./SapConfigurationPanel.vue?vue&type=template&id=5a36a94e&"
import script from "./SapConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./SapConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports